export default "__VITE_ASSET__DNou0jyb__"